import { createAsyncThunk } from '@reduxjs/toolkit';
import { plainAxiosInstance, securedAxiosInstance } from '../../../api/axios';

export const registerUser = createAsyncThunk(
  // action type string
  'user/register',
  // callback function
  async (
    { firstName, lastName, organisationName, email, password, confirmPassword },
    thunkApi
  ) => {
    try {
      // make request to backend
      await plainAxiosInstance.post('/register', {
        user: {
          first_name: firstName,
          last_name: lastName,
          email: email,
          organisation_name: organisationName,
          password: password,
          password_confirmation: confirmPassword,
          created_by: 'self',
        },
      });
    } catch (error) {
      console.log(error);
      // return custom error message from API if any
      if (error.response && error.response.data.errors) {
        return thunkApi.rejectWithValue(error.response.data.errors);
      } else {
        return thunkApi.rejectWithValue(error.message);
      }
    }
  }
);

export const userLogin = createAsyncThunk(
  'user/login',
  async ({ email, password }, thunkApi) => {
    try {
      const response = await plainAxiosInstance.post('/login', {
        user: { email, password },
      });
      // store user's token in local storage
      localStorage.setItem('userToken', response.headers.authorization);
      return response;
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.error) {
        return thunkApi.rejectWithValue(error.response.data.error);
      } else {
        return thunkApi.rejectWithValue(error.message);
      }
    }
  }
);

export const getUserDetails = createAsyncThunk(
  'user/getUserDetails',
  async (arg, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/me`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateUserDetail = createAsyncThunk(
  'user/updateUserDetail',
  async (
    { first_name, last_name, notification_subscription, company_role },
    { getState, rejectWithValue }
  ) => {
    try {
      const response = await securedAxiosInstance.post(`/me`, {
        user: { first_name, last_name, notification_subscription, company_role },
      });
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateProfileImage = createAsyncThunk(
  'user/updateProfileImage',
  async ({ formData, id }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.patch(
        `/users/${id}/image`,
        formData,
        {
          headers: {
            'Content-Type': 'image/jpeg',
          },
        }
      );
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updatePassword = createAsyncThunk(
  'user/updatePassword',
  async ({ password, confirmPassword }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.post(`/me_password`, {
        user: { password, password_confirmation: confirmPassword },
      });
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
